"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TezosConstants;
(function (TezosConstants) {
    TezosConstants.OperationGroupWatermark = '03';
    TezosConstants.DefaultSimpleTransactionFee = 1420;
    TezosConstants.DefaultTransactionStorageLimit = 496;
    TezosConstants.DefaultTransactionGasLimit = 10600;
    TezosConstants.DefaultDelegationFee = 1258;
    TezosConstants.DefaultDelegationStorageLimit = 0;
    TezosConstants.DefaultDelegationGasLimit = 1100;
    TezosConstants.DefaultAccountOriginationFee = 1266;
    TezosConstants.DefaultAccountOriginationStorageLimit = 496;
    TezosConstants.DefaultAccountOriginationGasLimit = 10600;
    TezosConstants.DefaultKeyRevealFee = 1270;
    TezosConstants.DefaultKeyRevealStorageLimit = 0;
    TezosConstants.DefaultKeyRevealGasLimit = 1100;
    TezosConstants.P005ManagerContractWithdrawalGasLimit = 26283;
    TezosConstants.P005ManagerContractDepositGasLimit = 15285;
    TezosConstants.P005ManagerContractWithdrawalStorageLimit = 496;
    TezosConstants.P001StorageRate = 1000000 / 1000;
    TezosConstants.P007StorageRate = 250000 / 1000;
    TezosConstants.StorageRate = TezosConstants.P007StorageRate;
    TezosConstants.BaseOperationFee = 100;
    TezosConstants.P007OperationGasCap = 1040000;
    TezosConstants.OperationGasCap = TezosConstants.P007OperationGasCap;
    TezosConstants.OperationStorageCap = 60000;
    TezosConstants.EmptyAccountStorageBurn = 257;
    TezosConstants.DefaultBakerVig = 100;
    TezosConstants.GasLimitPadding = 100;
    TezosConstants.StorageLimitPadding = 20;
    TezosConstants.HeadBranchOffset = 54;
    TezosConstants.DefaultBatchDelay = 25;
    TezosConstants.DefaultBlockTime = 60;
})(TezosConstants = exports.TezosConstants || (exports.TezosConstants = {}));
//# sourceMappingURL=TezosConstants.js.map